import('./bootstrap.tsx');

if (typeof module !== 'undefined' && module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.accept();
}
